import { Star, Trash2, Check, X, RotateCcw } from "lucide-react";

const STATUS_COLORS = {
  pending: "text-[#C5A059] border-[#C5A059]/50",
  approved: "text-emerald-300 border-emerald-300/40",
  rejected: "text-red-300 border-red-300/40",
};

const actionCls =
  "flex items-center gap-1.5 border border-[#2A2421] px-3 py-2 text-[10px] uppercase tracking-[0.2em] text-[#A8A29E] transition-colors";

const AdminReviews = ({ reviews, onStatus, onDelete }) => (
  <div className="space-y-4" data-testid="admin-reviews-list">
    {reviews.length === 0 && (
      <p className="border border-[#2A2421] bg-[#161311] p-10 text-center text-sm text-[#78716C]" data-testid="admin-reviews-empty">
        No guest reviews yet.
      </p>
    )}
    {reviews.map((r) => (
      <article key={r.id} data-testid={`admin-review-${r.id}`} className="border border-[#2A2421] bg-[#161311] p-6">
        <div className="flex flex-wrap items-start justify-between gap-4">
          <div>
            <h3 className="font-display text-xl text-[#F5F2EB]">{r.name}</h3>
            <p className="mt-1 text-xs text-[#78716C]">
              {r.city ? `${r.city} · ` : ""}
              {new Date(r.created_at).toLocaleString("en-IN")}
            </p>
          </div>
          <span className={`border px-3 py-1 text-[10px] uppercase tracking-[0.2em] ${STATUS_COLORS[r.status]}`} data-testid={`admin-review-status-${r.id}`}>
            {r.status}
          </span>
        </div>
        <div className="mt-3 flex gap-1" data-testid={`admin-review-rating-${r.id}`}>
          {Array.from({ length: r.rating }).map((_, s) => (
            <Star key={s} size={13} fill="#C5A059" className="text-[#C5A059]" />
          ))}
        </div>
        <p className="mt-3 font-display text-lg font-light italic leading-relaxed text-[#E4D9C5]">“{r.quote}”</p>
        <div className="mt-5 flex flex-wrap items-center gap-3">
          {r.status !== "approved" && (
            <button data-testid={`admin-approve-review-${r.id}`} onClick={() => onStatus(r.id, "approved")} className={`${actionCls} hover:border-emerald-300 hover:text-emerald-300`}>
              <Check size={12} /> Approve
            </button>
          )}
          {r.status !== "rejected" && (
            <button data-testid={`admin-reject-review-${r.id}`} onClick={() => onStatus(r.id, "rejected")} className={`${actionCls} hover:border-red-400 hover:text-red-400`}>
              <X size={12} /> Reject
            </button>
          )}
          {r.status !== "pending" && (
            <button data-testid={`admin-unpublish-review-${r.id}`} onClick={() => onStatus(r.id, "pending")} className={`${actionCls} hover:border-[#C5A059] hover:text-[#C5A059]`}>
              <RotateCcw size={12} /> Back to Pending
            </button>
          )}
          <button data-testid={`admin-delete-review-${r.id}`} onClick={() => onDelete(r.id)} className={`${actionCls} text-[#78716C] hover:border-red-400 hover:text-red-400`}>
            <Trash2 size={12} /> Delete
          </button>
        </div>
      </article>
    ))}
  </div>
);

export default AdminReviews;
